import 'core-js/stable'
import 'regenerator-runtime/runtime'

import React from 'react'
import ReactDOM from 'react-dom'

import Application from './app'
import initStore from './store'

const store = initStore()

ReactDOM.render(<Application store={store}/>, document.getElementById('application'))